import { useQuery } from '@tanstack/react-query';

import { supabaseClient } from 'src/auth/supabase';

import { queryRetry } from '../query-retry';

export const useIsUserAuthenticated = (enabled = true) => {
    const query = useQuery({
        enabled,
        queryKey: ['isUserAuthenticated'],
        queryFn: async () => {
            const { data, error } = await supabaseClient.auth.getSession();

            if (error) {
                throw error;
            }

            return data.session;
        },
        retry: queryRetry,
    });

    return { ...query };
};
